import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { LgvAPIService } from '../../core/services/lgv-api.service';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lus-company-select',
    templateUrl: './company-select.component.html',
    styleUrls: ['./company-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class CompanySelectComponent implements OnInit, OnDestroy {
    @Output() OnCompanySelected = new EventEmitter<any>();
    @Input() companyInitial;
    @Input() label;
    cobrandingCompany$ = new BehaviorSubject([]);
    company = new FormControl();
    
    companyList$ = new BehaviorSubject(<LgvModel.CompanyInfo[]>[]);
    constructor(
        public LgvApiSvc: LgvAPIService,
        public UsersSvc: LgvUserService,
        public cdr: ChangeDetectorRef
    ) {
        if (this.UsersSvc.IsCompanyAdmin) {
            this.UsersSvc.DBUserCompany$.pipe(takeWhile(x => x !== null)).subscribe(x => { this.companyInitial = x.id });
        }
    }

    ngOnInit() {
        const companyList = [<LgvModel.CompanyInfo>{
            name: 'All Companies'
        }];
        this.companyList$.next(companyList.concat(this.LgvApiSvc.Companies$.value));
        this.UsersSvc.CoBrandingRealEstateCompany$.pipe(takeWhile(f => f != null)).subscribe(res => {
            this.cobrandingCompany$.next(res);
        });
        this.company.setValue(this.companyInitial);
    }

    selectCompany(param) {
        if (param == undefined) {
            param = '';
        }
        this.OnCompanySelected.emit(param);
    }

    reset() {
        this.companyInitial = null;
        this.company.setValue(null);
        this.cdr?.detectChanges();
    }

    ngOnDestroy(): void {
        this.cdr?.detach();
        //this.UsersSvc.CobrandedRealEstatePartners$.next(null)
    }
}
